import React, { useState } from "react";
import { Comment } from "../../firebase/comments";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import Confirmation from "../shared/Confirmation";
import { deleteComment as deleteCommentFromDatabase } from "../../firebase/comments";
import { useTranslation } from "react-i18next";
import Tooltip from "../shared/Tooltip";

interface Props {
  comment: Comment;
}

export default function Delete({ comment }: Props) {
  const { t } = useTranslation();
  const [commentToDelete, setCommentToDelete] = useState<Comment | null>(null);

  async function deleteComment(comment: Comment) {
    await deleteCommentFromDatabase(comment.id);
  }

  return (
    <>
      <Tooltip title={t("comment.deletetooltip")}>
        <IconButton
          onClick={() => setCommentToDelete(comment)}
          aria-label={t("comment.deletetooltip")}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      {commentToDelete && (
        <Confirmation
          text={t("comment.confirmdelete")}
          handleConfirm={() => {
            deleteComment(commentToDelete);
            setCommentToDelete(null);
          }}
          handleCancel={() => setCommentToDelete(null)}
        />
      )}
    </>
  );
}
